import { TicketStoreItem } from '@givebacks/api/store';
import { DateTime } from 'luxon';

const filterNonExpiredTickets = (ticket: TicketStoreItem) => {
  // if expires_at is null, it is not expired
  if (!ticket.expires_at) {
    return true;
  }

  const now = DateTime.now();
  const expirationDate = DateTime.fromISO(ticket.expires_at);

  return now < expirationDate;
};

export { filterNonExpiredTickets };
